import React from "react";
import { Card, Progress } from "reactstrap";
import { Bell, ChevronRight, CheckCircle } from "react-feather";
import { Link } from "react-router-dom";
import { routes } from "../../../routes/routes";

interface IIngredientActionsCardProps {
    notificationsCount: number;
    totalActions: number;
    actionsPendingCount: number;
}

const IngredientActionsCard: React.FC<IIngredientActionsCardProps> = ({
    notificationsCount,
    totalActions,
    actionsPendingCount
}) => {
    const progress = totalActions > 0 ? (notificationsCount / totalActions) * 100 : 0;
    const isAllCaughtUp = notificationsCount === 0 && actionsPendingCount === 0;

    return (
        <Card className="product-actions-card border-0 shadow-sm h-100">
            <div className="card-content-wrapper p-4">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <div className="d-flex align-items-center">
                        <div className="icon-wrapper mr-2">
                            <Bell size={20} />
                        </div>
                        <h5 className="mb-0 font-weight-bold" style={{ color: "#334155" }}>Ingredient Actions</h5>
                    </div>
                    <div className="badge badge-light px-2 py-1 text-muted" style={{ backgroundColor: "#f1f5f9" }}>
                        {notificationsCount}/{totalActions}
                    </div>
                </div>

                <div className="mb-4">
                    <div className="d-flex justify-content-between mb-1">
                        <span className="text-muted small">Progress</span>
                        <span className="text-muted small font-weight-bold">{Math.round(progress)}%</span>
                    </div>
                    <Progress value={progress} className="action-progress-bar" />
                </div>

                <div className="action-items">
                    <div className="action-item mb-3 p-3 rounded d-flex justify-content-between align-items-center notification-item">
                        <div className="d-flex align-items-center">
                            <div className="count-circle mr-3">{notificationsCount}</div>
                            <span className="font-weight-bold">Notifications Pending</span>
                        </div>
                        <Link to={routes.NOTIFICATIONS} className="view-all-link small">
                            View all <ChevronRight size={14} />
                        </Link>
                    </div>

                    <div className="action-item mb-3 p-3 rounded d-flex justify-content-between align-items-center action-pending-item">
                        <div className="d-flex align-items-center">
                            <div className="count-circle mr-3">{actionsPendingCount}</div>
                            <span className="font-weight-bold">Actions Pending</span>
                        </div>
                        <Link to={routes.NOTIFICATIONS} className="view-all-link small">
                            View all <ChevronRight size={14} />
                        </Link>
                    </div>

                    {isAllCaughtUp && (
                        <div className="all-caught-up-status d-flex flex-column align-items-center justify-content-center mt-3">
                            <div className="check-icon-wrapper mb-2">
                                <CheckCircle size={32} color="#10b981" fill="rgba(16, 185, 129, 0.1)" />
                            </div>
                            <span className="font-weight-bold text-dark mb-0">All caught up!</span>
                            <span className="small text-muted">No pending actions</span>
                        </div>
                    )}
                </div>
            </div>
        </Card>
    );
};

export default IngredientActionsCard;
